export default "__VITE_ASSET__fd44f460__"